module.exports = __webpack_public_path__ + "img/clock_hour_minute_second_time_timer_watch_icon_123193.f6dbdae6.svg";